import { createClient } from '@supabase/supabase-js';

// Replace these with your actual Supabase URL and public key
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'YOUR_SUPABASE_URL';
const supabaseAnonKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY || 'YOUR_SUPABASE_ANON_KEY';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: 'altzero',
  },
  auth: {
    // Enable session persistence
    persistSession: true,
    // Auto refresh session
    autoRefreshToken: true,
    // Detect session in URL
    detectSessionInUrl: true,
    // Storage key for session
    storageKey: 'supabase.auth.token',
    // Storage type
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    // Flow type
    flowType: 'pkce',
  },
});

export type AltzeroSupabaseClient = typeof supabase;

// CRM Base client with crm_base schema
export const crmBaseSupabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: 'crm_base',
  },
  auth: {
    // Enable session persistence
    persistSession: true,
    // Auto refresh session
    autoRefreshToken: true,
    // Detect session in URL
    detectSessionInUrl: true,
    // Storage key for session
    storageKey: 'supabase.auth.token',
    // Storage type
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    // Flow type
    flowType: 'pkce',
  },
});

export const setupSessionRefresh = async (): Promise<
  (() => void) | undefined
> => {
  try {
    // Get the current session first
    const { data, error } = await supabase.auth.getSession();

    if (error || !data.session) {
      console.log('No active session found, skipping session refresh setup');
      return undefined;
    }

    // Setup a refresh interval (e.g., every 23 hours to avoid token expiration)
    const REFRESH_INTERVAL = 23 * 60 * 60 * 1000; // 23 hours in milliseconds

    const refreshSession = async () => {
      const { data, error } = await supabase.auth.refreshSession();
      if (error) {
        console.error('Error refreshing session:', error);
      } else {
        console.log('Session refreshed successfully');
      }
    };

    // Set up interval
    const interval = setInterval(refreshSession, REFRESH_INTERVAL);
    console.log('Session refresh interval set up successfully');

    // Return cleanup function
    return () => {
      clearInterval(interval);
      console.log('Session refresh interval cleared');
    };
  } catch (error) {
    console.error('Failed to setup session refresh:', error);
    return undefined;
  }
};
